var render = function render(){var _vm=this,_c=_vm._self._c;return _c('loading-state',{attrs:{"message":_vm.$t('CONFIRM_EMAIL')}})
}
var staticRenderFns = []

export { render, staticRenderFns }